/* component-localization-form.js — <localization-form>
   Native Shopify localization form.
   - Block style (footer + mobile drawer): a <select>; on change, submit the form.
     Without JS the visible <noscript> submit button is the fallback.
   - Compact style (desktop header): a native <details> disclosure whose options are
     real submit buttons. Native details/summary already handle keyboard + click
     toggling; JS only adds close-on-outside-click and close-on-Escape. Works
     without JS (the disclosure and submit buttons are fully native). */
(function () {
  'use strict';

  class LocalizationForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.select = this.querySelector('select');
      this.disclosure = this.querySelector('details[data-loc-disclosure]');

      // Block style: auto-submit on select change.
      if (this.form && this.select) {
        this._onChange = this._onChange.bind(this);
        this.select.addEventListener('change', this._onChange);
      }

      // Compact style: enhance the disclosure with outside-click / Escape close.
      if (this.disclosure) {
        this.summary = this.disclosure.querySelector('summary');
        this._onDocClick = this._onDocClick.bind(this);
        this._onKeydown = this._onKeydown.bind(this);
        this._onToggle = this._onToggle.bind(this);
        this.disclosure.addEventListener('toggle', this._onToggle);
      }
    }

    disconnectedCallback() {
      if (this.select && this._onChange) this.select.removeEventListener('change', this._onChange);
      if (this.disclosure && this._onToggle) this.disclosure.removeEventListener('toggle', this._onToggle);
      this._unbindGlobal();
    }

    _onChange() {
      if (this.form.requestSubmit) this.form.requestSubmit();
      else this.form.submit();
    }

    _onToggle() {
      if (this.disclosure.open) {
        document.addEventListener('click', this._onDocClick);
        document.addEventListener('keydown', this._onKeydown);
      } else {
        this._unbindGlobal();
      }
    }

    _unbindGlobal() {
      if (this._onDocClick) document.removeEventListener('click', this._onDocClick);
      if (this._onKeydown) document.removeEventListener('keydown', this._onKeydown);
    }

    _onDocClick(event) {
      if (!this.disclosure.contains(event.target)) this._close();
    }

    _onKeydown(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        this._close();
        if (this.summary) this.summary.focus();
      }
    }

    _close() {
      this.disclosure.open = false;
    }
  }

  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', LocalizationForm);
  }
})();
